export default __webpack_public_path__ + "static/media/next.f757719c.svg";